const DASHBOARD = '/dashboard';

const PERFORMANCE_REPORTING = `${DASHBOARD}/performance-reporting`;
const PERFORMANCE_REPORTING_OVERALL_PERFORMANCE = `${PERFORMANCE_REPORTING}/overall-performance`;
const PERFORMANCE_REPORTING_AUDIENCE_ANALYSIS = `${PERFORMANCE_REPORTING}/audience-analysis`;
const PERFORMANCE_REPORTING_CURRENT_PLANNED = `${PERFORMANCE_REPORTING}/current-plan-spend`;
const PERFORMANCE_REPORTING_ACTUAL_SPEND = `${PERFORMANCE_REPORTING}/actual-spend`;
const PERFORMANCE_REPORTING_ROLL_UP_SPEND = `${PERFORMANCE_REPORTING}/weekly-roll-up-spend`;
const PERFORMANCE_REPORTING_OFFERS_CREATIVES = `${PERFORMANCE_REPORTING}/offers-and-creatives`;
const PERFORMANCE_REPORTING_SPEND_OPPORTUNITIES = `${PERFORMANCE_REPORTING}/spend-opportunities`;
const PERFORMANCE_REPORTING_OPPORTUNITIES_BY_CHANNEL = `${PERFORMANCE_REPORTING}/opportunities-by-channel`;
const PERFORMANCE_REPORTING_ACTUAL_VS_BUDGET = `${PERFORMANCE_REPORTING}/actual-vs-budget`;
const PERFORMANCE_REPORTING_INITIAL_PLAN_SPEND = `${PERFORMANCE_REPORTING}/initial-plan-spend`;

// Routes to be as it is
const BRANCH_PERFORMANCE = `${DASHBOARD}/branch-performance`;
const BRANCH_PERFORMANCE_PERFORMANCE_OVERVIEW = `${BRANCH_PERFORMANCE}/performance-overview`;
const BRANCH_PERFORMANCE_OPPORTUNITIES_INSIGHTS = `${BRANCH_PERFORMANCE}/opportunities-insights`;

// Routes to be as it is
export const SUB_BRANCH_DASHBOARD = `${DASHBOARD}/sub-branch-dashboard`;
const SUB_BRANCH_DASHBOARD_OVERALL_PERFORMANCE = `${SUB_BRANCH_DASHBOARD}/overall-performance-sub-branch`;
const SUB_BRANCH_DASHBOARD_OPPS_BY_CHANNEL = `${SUB_BRANCH_DASHBOARD}/opps-by-channel-sub-branch`;
const SUB_BRANCH_DASHBOARD_PERFORMANCE_OVERVIEW = `${SUB_BRANCH_DASHBOARD}/performance-overview-sub-branch`;

const PROMOTIONS = `${DASHBOARD}/promotions`;

export const PROMOTIONS_TIMELINE_VIEW = `${PROMOTIONS}/timeline`;
export const PROMOTIONS_TIMELINE_VIEW_PRINT = `${PROMOTIONS}/timeline/print`;
export const CREATE_PROMOTIONS = `${PROMOTIONS}/create`;
export const EDIT_PROMOTIONS = `${PROMOTIONS}/edit`;

const EMAIL_AD_VALIDATION = `${DASHBOARD}/email-ad-validation`;

// updated routes for dashboard sections
const EXECUTIVE_SUMMARY = `${DASHBOARD}/executive-summary`;
const EXECUTIVE_SUMMARY_OVERALL_PERFORMANCE = `${EXECUTIVE_SUMMARY}/overall-performance`;
const EXECUTIVE_SUMMARY_SPEND_OPPORTUNITIES = `${EXECUTIVE_SUMMARY}/spend-opportunities`;

const SPEND = `${DASHBOARD}/spend`;
const SPEND_INITIAL_PLAN = `${SPEND}/initial-plan-spend`;
const SPEND_CURRENT_PLAN = `${SPEND}/current-plan-spend`;
const SPEND_ACTUAL = `${SPEND}/actual-spend`;
const SPEND_ACTUAL_VS_BUDGET = `${SPEND}/actual-vs-budget`;

const OPPORTUNITIES = `${DASHBOARD}/opportunities`;
const OPPORTUNITIES_INITIAL_PLAN = `${OPPORTUNITIES}/initial-plan-opportunites`;
const OPPORTUNITIES_BY_CHANNEL_LAST_TOUCH = `${OPPORTUNITIES}/opportunities-by-channel-last-touch`;
const OPPORTUNITIES_BY_CHANNEL_TRUE_IMPACT = `${OPPORTUNITIES}/opportunities-by-channel-mmm-true-impact`;

const WIP = `${DASHBOARD}/wip`;
const WIP_AUDIENCE_ANALYSIS = `${WIP}/audience-analysis`;

export const ROUTES = {
  dashboard: DASHBOARD,
  map: `${DASHBOARD}/map`,
  performanceReporting: `${DASHBOARD}/performance-reporting/overall-performance`,
  promotions: PROMOTIONS,
  emailAdValidation: EMAIL_AD_VALIDATION,
  creatives: `${DASHBOARD}/creatives`,
  createPromotions: CREATE_PROMOTIONS,
  editPromotions: `${EDIT_PROMOTIONS}/:id`,
  overallPerformance: PERFORMANCE_REPORTING_OVERALL_PERFORMANCE,
  spendOpportunties: PERFORMANCE_REPORTING_SPEND_OPPORTUNITIES,
  audienceAnalysis: PERFORMANCE_REPORTING_AUDIENCE_ANALYSIS,
  currentPlanned: PERFORMANCE_REPORTING_CURRENT_PLANNED,
  weeklyRollUpSpend: PERFORMANCE_REPORTING_ROLL_UP_SPEND,
  offersAndCreatives: PERFORMANCE_REPORTING_OFFERS_CREATIVES,
  actualSpend: PERFORMANCE_REPORTING_ACTUAL_SPEND,
  login: '/auth/login',
  oktaLogin: '/okta-callback',
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/user/resetpassword/:uidb64/:token',
  table: 'table',
  commonComponentDemo: 'demo',
  collapsableTable: '/collapsable-table',
  performanceOverview: BRANCH_PERFORMANCE_PERFORMANCE_OVERVIEW,
  opportunitiesInsights: BRANCH_PERFORMANCE_OPPORTUNITIES_INSIGHTS,
  opportunitiesByChannel: PERFORMANCE_REPORTING_OPPORTUNITIES_BY_CHANNEL,
  actualVsBudget: PERFORMANCE_REPORTING_ACTUAL_VS_BUDGET,
  initialPlanSpend: PERFORMANCE_REPORTING_INITIAL_PLAN_SPEND,
  subBranchOverallPerformance: SUB_BRANCH_DASHBOARD_OVERALL_PERFORMANCE,
  subBranchOppsByChannel: SUB_BRANCH_DASHBOARD_OPPS_BY_CHANNEL,
  subBranchPerformanceOverview: SUB_BRANCH_DASHBOARD_PERFORMANCE_OVERVIEW,
  executiveSummaryOverallPerformance: EXECUTIVE_SUMMARY_OVERALL_PERFORMANCE,
  executiveSummarySpendAndOpportunities: EXECUTIVE_SUMMARY_SPEND_OPPORTUNITIES,
  spendInitialPlanSPend: SPEND_INITIAL_PLAN,
  spendCurrentPlan: SPEND_CURRENT_PLAN,
  spendActual: SPEND_ACTUAL,
  spendActualVsBudget: SPEND_ACTUAL_VS_BUDGET,
  oppsInitialPlanSpend: OPPORTUNITIES_INITIAL_PLAN,
  opportunitiesByChannelLastTouch: OPPORTUNITIES_BY_CHANNEL_LAST_TOUCH,
  opportunitiesByChannelTrueImpact: OPPORTUNITIES_BY_CHANNEL_TRUE_IMPACT, // not added currently
  wipAudienceAnalysis: WIP_AUDIENCE_ANALYSIS,
};
